import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/icon.css'; //element-ui 图标库
import iconPicker from 'e-icon-picker';
import axios from 'axios'
Vue.prototype.$axios = axios;//把axios挂载到vue上
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(iconPicker, { ElementUI: true, });
/* 路由守卫 */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')